import React from 'react';

const ThirdBar: React.FC<{ label: string; value: number; total: number; color: string }> = ({ label, value, total, color }) => {
  const pct = total > 0 ? (value / total) * 100 : 0;
  return (
    <div className="flex-1">
      <div className="text-[10px] text-gray-500 dark:text-gray-400 text-center mb-0.5">
        {label} ({value})
      </div>
      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
        <div className={`${color} rounded-full h-2`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default ThirdBar;
